import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CO2Service from '~/api/services/co2'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import Results from './AnswerCO2Climate/Steps/Results'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId, farmerId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState(false)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await CO2Service.getCO2SubmitData(id, { farmerId })
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id)}
    isLoading={isBusy}
    style={{ width: '80%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      <Results results={submitPreviewData} removeMargin />
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal